export default __webpack_public_path__ + "static/media/Discord.b5bd5243.png";